import { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ArrowRight, Star } from 'lucide-react';
import './marketing/reviews.css';

const TESTIMONIALS = [
  { quote: "I really liked this app. It's simple, easy to use, and helps me find my classes and rooms quickly", name: 'Syeda Khadija', role: 'Computer Science · Semester 4', initials: 'SK', subject: 'Well designed and useful', rating: 5 },
  { quote: "You did such an amazing job. It's created ease n convenience n all. Keep it up!", name: 'Afaq Ahmad', role: 'BBA · Semester 3', initials: 'AA' },
  { quote: 'Such an incredible application! Its design and data in it … seem like developer has experience of yrs !!', name: 'Khurram Khan', role: 'IMS student', initials: 'KK' },
  { quote: 'Amazing Work Brother', name: 'Abdul Mateen', role: 'IMS student', initials: 'AM' },
];

export function TestimonialsSection() {
  const [active, setActive] = useState(0);
  const reducedMotion = useReducedMotion();
  const student = TESTIMONIALS[active];

  return (
    <section className="mk-reviews mk-section" aria-labelledby="mk-reviews-heading">
      <div className="mk-container">
        <div className="mk-reviews-topline">
          <p className="mk-eyebrow">04 / CAMPUS VOICES</p>
          <span>Small notes. Real impact.</span>
        </div>
        <div className="mk-reviews-intro">
          <h2 id="mk-reviews-heading">A little easier.<br /><em>In their words.</em></h2>
          <p>Finding a room. Making a class.{' '}<br />A little less to think about.{' '}<br /><span>Here’s what that feels like.</span></p>
        </div>
        <div className="mk-reviews-layout">
          <div className="mk-reviews-paper">
            <div className="mk-reviews-paper-top" aria-hidden="true"><span>A NOTE FROM CAMPUS</span><span>0{active + 1} / 04</span></div>
            <div className="mk-reviews-stage" id="mk-review-current" aria-live="polite" aria-atomic="true">
              <AnimatePresence mode="wait" initial={false}>
                <motion.figure key={student.name} initial={{ opacity: reducedMotion ? 1 : 0, y: reducedMotion ? 0 : 8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: reducedMotion ? 1 : 0 }} transition={{ duration: reducedMotion ? 0 : .18 }}>
                  <div className="mk-reviews-quote-meta">
                    <span className="mk-reviews-quote-mark" aria-hidden="true">“</span>
                    {student.rating && <span className="mk-reviews-rating" role="img" aria-label={`${student.rating} out of 5 stars`}>{Array.from({ length: student.rating }, (_, index) => <Star key={index} size={13} fill="currentColor" aria-hidden="true" />)}<span aria-hidden="true">5 / 5</span></span>}
                  </div>
                  <blockquote>{student.quote}</blockquote>
                  <figcaption><span className="mk-reviews-signature">{student.name}</span><span>{student.subject ?? student.role}</span></figcaption>
                </motion.figure>
              </AnimatePresence>
            </div>
            <span className="mk-reviews-paper-rule" aria-hidden="true" />
          </div>
          <div className="mk-reviews-directory">
            <p className="mk-reviews-directory-label">THE PEOPLE, THE PERSPECTIVES</p>
            <div className="mk-reviews-people" role="group" aria-label="Choose a student review">
              {TESTIMONIALS.map((item, index) => (
                <button key={item.name} type="button" className="mk-reviews-person" aria-label={`Read ${item.name}'s review`} aria-pressed={active === index} aria-controls="mk-review-current" onClick={() => setActive(index)}>
                  <span className="mk-reviews-initials" aria-hidden="true">{item.initials}</span>
                  <span className="mk-reviews-person-info"><strong>{item.name}</strong><small>{item.role}</small></span>
                  <ArrowRight size={18} strokeWidth={1.5} aria-hidden="true" />
                </button>
              ))}
            </div>
            <p className="mk-reviews-directory-note"><span aria-hidden="true">↳</span> Built around real campus days.<br />Shaped by the people living them.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
export default TestimonialsSection;
